<div id="user-settings-permissions" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ PANELS.PERMISSIONS.name }}</div>
      <div class="subtitle">
        {{ PANELS.PERMISSIONS.description }}
      </div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="panel-body">
    <form [formGroup]="form" (submit)="submitChanges()" class="settings-panel-form">
      <mat-tab-group color="primary" class="permissions-settings-tabs" [disableRipple]="true">
        <mat-tab [label]="'General' | translate">
          <app-custom-expansion-panel
            class="no-padding"
            [title]="'Spaces Access' | translate"
            [description]="'Adjust default access settings in a Space' | translate"
          >
            <div class="toggle-group-fields no-border">
              <div class="control-row-container">
                <div class="control-row-content">
                  <div class="row-details">
                    <div class="_title">{{ 'Default Space access' | translate }}</div>
                    <div class="_subtitle">
                      {{
                        'Set the default access of new Spaces created in your institution'
                          | translate
                      }}
                    </div>
                  </div>
                </div>
                <div class="control-dropdown">
                  <app-pencil-button
                    class="dropdown-visibility-toggle"
                    [matMenuTriggerFor]="visibilityMenuComponent.menu"
                    #menuTrigger="matMenuTrigger"
                    buttonType="button"
                  >
                    <span>{{
                      form?.value?.settings?.defaultSpaceVisibility | translate | titlecase
                    }}</span>
                    <app-pencil-icon
                      [name]="menuTrigger.menuOpen ? 'expand_less' : 'expand_more'"
                      [type]="IconTypes.matIcon"
                    ></app-pencil-icon>
                  </app-pencil-button>
                  <app-visibility-menu
                    #visibilityMenuComponent
                    [selectedValue]="form?.value?.settings?.defaultSpaceVisibility"
                    (valueChanged)="onVisibilityChanged($event)"
                  ></app-visibility-menu>
                </div>
              </div>

              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'preventMakingSpacesPublic',
                  titleText: 'Restrict Spaces from being made public' | translate,
                  disableOptions: {
                    disabled: isDefaultSpaceVisibilityPublic,
                    reason: defaultSpaceVisibilityPublicDisabledTooltip
                  },
                  activeText:
                    'Spaces cannot be made publicly accessible. Existing public Spaces are not affected.'
                    | translate,
                  inactiveText:
                    'Spaces cannot be made publicly accessible. Existing public Spaces are not affected.'
                    | translate
                }"
              >
              </app-user-settings-permissions-toggle>
              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'preventAddingExternalUsersToSpaces',
                  titleText: 'Restrict Spaces to institution members only' | translate,
                  disableOptions: {
                    disabled: isDefaultSpaceVisibilityPublic,
                    reason: defaultSpaceVisibilityPublicDisabledTooltip
                  },
                  activeText:
                    'Spaces cannot be shared with users outside your institution. Existing Spaces are not affected.'
                    | translate,
                  inactiveText:
                    'Spaces cannot be shared with users outside your institution. Existing Spaces are not affected.'
                    | translate
                }"
              >
              </app-user-settings-permissions-toggle>
            </div>
          </app-custom-expansion-panel>

          <div class="toggle-group">
            <div class="toggle-group-fields">
              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'addAdminsAsHostsInSpace',
                  titleText: 'Grant admins access to all Spaces' | translate,
                  activeText:
                    'Disabling this feature will not remove admins from any Spaces they may have already joined.'
                    | translate,
                  inactiveText:
                    'Enabling will allow admins to join any Space in the institution as a host.'
                    | translate
                }"
              >
              </app-user-settings-permissions-toggle>
              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'autoDesignateTeachersAsHosts',
                  titleText:
                    'Automatically make teachers / institution admins hosts when they join a public Space in your institution'
                    | translate,
                  activeText:
                    'Disabling this feature will not change the roles of these users in any of their existing Spaces'
                    | translate,
                  inactiveText:
                    'Enabling this feature will not change the role of these users in any of their existing Spaces'
                    | translate
                }"
              >
              </app-user-settings-permissions-toggle>
              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'preventTeachersfromCreatingSpaces',
                  titleText:
                    'Prevent teachers from creating their own Spaces in your institution'
                    | translate,
                  activeText:
                    'Disabling this feature means teachers can create their own Spaces in your institution'
                    | translate,
                  inactiveText:
                    'Enabling this feature will not remove a teacher\'s access to any of their existing Spaces'
                    | translate
                }"
              >
              </app-user-settings-permissions-toggle>
              <app-user-settings-permissions-toggle
                [formGroup]="form"
                [options]="{
                  setting: 'preventStudentsFromEditingDetails',
                  titleText: 'Restrict students from editing their profile' | translate,
                  activeText: 'Allow students to change their name or profile photo' | translate,
                  inactiveText:
                    'Prevent students from changing their name or profile photo' | translate
                }"
              >
              </app-user-settings-permissions-toggle>
            </div>
          </div>

          <div class="column-container section-container" *ngIf="isObserverModeEnabled$ | async">
            <div class="section-title">
              {{ 'Observer' | translate }}
            </div>

            <app-user-settings-warning
              [theme]="UserSettingsWarningTheme.WARNING"
              [title]="'Before enabling, please consult legal counsel' | translate"
              [description]="
                'Laws regarding monitoring vary by jurisdiction. You should consult legal counsel before enabling hidden observation.'
                  | translate
              "
            >
            </app-user-settings-warning>

            <div class="toggle-group">
              <div class="toggle-group-fields">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'allowAdminsAsObserversInSpace',
                    titleText: 'Allow admins to join Spaces as an observer' | translate,
                    activeText:
                      'Admins can join Spaces as hidden observers to monitor sessions without being detected.'
                      | translate,
                    inactiveText:
                      'Admins can join Spaces as hidden observers to monitor sessions without being detected.'
                      | translate,
                    suffixLink: {
                      text: 'Learn more' | translate,
                      url: observerModeLearnMoreUrl
                    }
                  }"
                >
                </app-user-settings-permissions-toggle>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          [label]="'Recording' | translate"
          *ngIf="featureManagementService.isCloudRecordingCapabilityEnabled$ | async"
        >
          <div class="recording-warning">
            <div class="title-container">
              <i class="material-icons">warning_amber</i>
              <span class="title">
                {{ 'Before enabling, please consult with a lawyer' | translate }}</span
              >
            </div>

            <span class="description">
              {{
                'The laws governing consent to record vary depending on the jurisdiction of your institution. It is highly advisable to seek legal counsel before enabling this feature.'
                  | translate
              }}
            </span>
          </div>
          <div class="recording-options-selector">
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'settings'"
              [options]="{
                setting: 'crRecordingMode',
                selections: [
                  {
                    value: RecordingMode.AUTOMATIC,
                    title: 'Always-on recording' | translate,
                    description:
                      'Every call is automatically recorded to the cloud. Stopping or pausing a recording is disabled. Only admins can disable recording in a Space.'
                      | translate,
                    disableOptions: {
                      disabled:
                        (canUseAutomaticRecording$ | async) === false ||
                        (isParticipantRecordingEnabled$ | async),
                      reason:
                        (isParticipantRecordingEnabled$ | async)
                          ? participantRecordingDisabledTooltip
                          : featureManagementService.featureUnavailableTooltip.message
                    },
                    subToggleInputs: isRecordWbOnCloudEnabled
                      ? []
                      : [
                          {
                            setting: 'forceScreenShareInAutomaticCr',
                            titleText:
                              'Require hosts to record their current window on all calls'
                              | translate,
                            disableOptions: {
                              disabled:
                                (canUseAutomaticRecording$ | async) === false ||
                                form?.value?.settings['crRecordingMode'] !== RecordingMode.AUTOMATIC
                            }
                          }
                        ]
                  },
                  {
                    value: RecordingMode.MANUAL,
                    title: 'Host recording' | translate,
                    description:
                      'Hosts can choose to enable recording in their Spaces. Starting and Stopping a recording is possible.'
                      | translate,
                    disableOptions: {
                      disabled: isParticipantRecordingEnabled$ | async,
                      reason: participantRecordingDisabledTooltip
                    },
                    subToggleInputs: [
                      {
                        setting: 'preventHostsFromRecordingLocally',
                        titleText: 'Prevent hosts from recording locally' | translate,
                        disableOptions: {
                          disabled:
                            form?.value?.settings['crRecordingMode'] !== RecordingMode.MANUAL
                        }
                      }
                    ]
                  },
                  {
                    value: RecordingMode.DISABLED,
                    title: 'Disabled' | translate,
                    description:
                      'All recording options are hidden for all users in a Space, including admins.'
                      | translate,
                    disableOptions: {
                      disabled: isParticipantRecordingEnabled$ | async,
                      reason: participantRecordingDisabledTooltip
                    }
                  }
                ]
              }"
            >
            </app-user-settings-permissions-select>
          </div>
          <div class="column-container section-container">
            <div class="section-title">
              {{ 'Recording permissions' | translate }}
            </div>
            <div class="toggle-group">
              <div class="toggle-group-fields">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'crEnableDownloads',
                    titleText:
                      'Allow non-admin hosts to download recordings from Session Analytics or Files'
                      | translate
                  }"
                ></app-user-settings-permissions-toggle>
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'crEnableHostDeletion',
                    titleText:
                      'Allow non-admin hosts to delete recordings from Session Analytics'
                      | translate
                  }"
                ></app-user-settings-permissions-toggle>
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'crEnablePrivacyAwareCloudRecording',
                    titleText: 'Prevent participant video from being recorded' | translate,
                    disableOptions: {
                      disabled: (canUsePrivacyAwareCloudRecording$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    }
                  }"
                ></app-user-settings-permissions-toggle>
              </div>
            </div>
          </div>
          <div class="column-container section-container">
            <div class="section-title">
              {{ 'Recording access' | translate }}
            </div>
            <div class="toggle-group">
              <div class="toggle-group-fields">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'crForceAdminOnlyAccess',
                    titleText: ('Only allow admins to access recordings' | translate),
                    activeText:
                      ('All recordings are restricted to admins only. Hosts and participants cannot access recordings'
                      | translate),
                    inactiveText: ('Recordings are not restricted to admins only.' | translate)
                  }"
                >
                </app-user-settings-permissions-toggle>
                <ng-container *ngIf="!form?.value?.settings?.crForceAdminOnlyAccess">
                  <app-user-settings-permissions-toggle
                    *ngIf="!isNewSessionsFlowEnabled"
                    [formGroup]="form"
                    [options]="{
                      setting: 'crEnablePublicRecordings',
                      titleText: ('Allow recordings to be made public' | translate),
                      activeText:
                        ('Let hosts share recordings publicly. Only hosts can change a recording\'s access to public'
                        | translate),
                      inactiveText:
                        ('Recordings can be accessed either by hosts only or by anyone in the Space'
                        | translate)
                    }"
                  >
                  </app-user-settings-permissions-toggle>
                  <app-user-settings-permissions-dropdown
                    [title]="'Default recording access' | translate"
                    [description]="'Choose who can view new recordings by default' | translate"
                    [selectedValue]="
                      spaceRecordingService.RecordingAccessEnumToTextMapping[
                        displayedDefaultRecordingAccess
                      ]
                    "
                    [options]="(recordingAccessOptions$ | async) ?? []"
                    [bindValue]="'value'"
                    [bindLabel]="'label'"
                    [placeholder]="'Select recording access' | translate"
                    (optionSelected)="setDefaultRecordingAccess($event)"
                  >
                  </app-user-settings-permissions-dropdown>
                </ng-container>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab [label]="'Inside Spaces' | translate">
          <app-custom-expansion-panel
            *ngIf="isExportImportSpaceFileEnabled"
            [title]="'Download Spaces or boards' | translate"
            [description]="'Adjust download settings across all Spaces' | translate"
          >
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'permissions'"
              [options]="downloadSpacesOrBoardsOptions"
            >
            </app-user-settings-permissions-select>
          </app-custom-expansion-panel>
          <app-custom-expansion-panel
            [title]="'Leader Mode' | translate"
            [description]="'Adjust default Leader Mode settings for all Spaces' | translate"
          >
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'permissions'"
              [options]="leaderModeOptions"
            >
            </app-user-settings-permissions-select>
          </app-custom-expansion-panel>
          <app-custom-expansion-panel
            *ngIf="featureManagementService.childModeCapabilityEnabled$ | async"
            [title]="'Child Mode' | translate"
            [description]="'Adjust default Child Mode settings for all Spaces' | translate"
          >
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'permissions'"
              [options]="childModeOptions"
            >
            </app-user-settings-permissions-select>
          </app-custom-expansion-panel>
          <app-custom-expansion-panel
            [title]="'Waiting Room' | translate"
            [description]="
              'Adjust default Waiting Room settings in a Space. Even if Waiting Rooms are turned off, guest users will still need to sign-in to open a Space'
                | translate
            "
          >
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'permissions'"
              [options]="waitingRoomOptions"
            >
            </app-user-settings-permissions-select>
          </app-custom-expansion-panel>
          <app-custom-expansion-panel
            [title]="'Participant-to-participant messaging' | translate"
            [description]="
              'Adjust whether participants can message other participants in a Space. Participants can always message hosts directly.'
                | translate
            "
          >
            <app-user-settings-permissions-select
              [formGroup]="form"
              [formGroupName]="'permissions'"
              [options]="messageOtherParticipantsOptions"
            >
            </app-user-settings-permissions-select>
          </app-custom-expansion-panel>
        </mat-tab>
      </mat-tab-group>
      <div class="foot" [class.show]="formChanged$ | async">
        <app-pencil-button
          class="pencil-button btn-ok"
          [buttonType]="'submit'"
          [disabled]="form.invalid"
        >
          <span *ngIf="!isLoading" class="material-icons">check</span>
          <mat-spinner *ngIf="isLoading" [diameter]="16" color="#FFF"></mat-spinner>
          <span>{{ 'Update' | translate }}</span>
        </app-pencil-button>
        <app-pencil-button
          [buttonType]="'button'"
          class="pencil-button btn-cancel"
          (clickEvent)="initForm()"
          type="button"
          icon="close"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Cancel' | translate"
        >
        </app-pencil-button>
      </div>
    </form>
  </div>
</div>
